import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { useOnMount } from '~/hooks/useOnMount';
const MobileOptimizedViewContext = /*#__PURE__*/ createContext({
    setMobileViewportType: ()=>{}
});
const typeToContent = {
    standard: 'width=1280',
    optimized: 'width=device-width, initial-scale=1.0, maximum-scale=1.0'
};
/** Controls the viewport width in mobile devices. */ export function MobileViewportWidthProvider(param) {
    let { children } = param;
    const [type, setType] = useState('standard');
    const value = useMemo(()=>({
            setMobileViewportType: setType
        }), []);
    return /*#__PURE__*/ _jsxs(MobileOptimizedViewContext.Provider, {
        value: value,
        children: [
            /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx("meta", {
                name: "viewport",
                content: typeToContent[type],
                "data-testid": "viewport"
            }), document.head),
            children
        ]
    });
}
/**
 * When a page is wrapped by this higher-order component, it tells the mobile-browser that it's a mobile-optimized page
 * and the browser will enforce viewport width to be the device width.
 */ export function withOptimizedMobileViewport(Component) {
    return function WithOptimizedMobileViewport(props) {
        const { setMobileViewportType } = useContext(MobileOptimizedViewContext);
        useOnMount(()=>{
            setMobileViewportType('optimized');
            return ()=>setMobileViewportType('standard');
        });
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
}
